import { fontType, main } from '../assets/extras'
import { IoIosClose } from "react-icons/io"
import './styles/ticketmodal.css'

const TicketModal = ({ ticket, setTicket, onHandleGenerateTicket }) => {
    
    //Funcion que cambia la opcion seleccionada
    const onChangeOption = (value) => {
        setTicket(prev => ({
            ...prev,
            forma_pago: value
        }))
    }

    return (
        <div className='mainTicketModal' style={{
            opacity: ticket.show ? 1 : 0,
            zIndex: ticket.show ? 1 : -1000,
        }}>
            <div className='ticketCont'>

                <div style={{
                    width: "100%",
                    textAlign: "right"
                }}>

                    <IoIosClose size={30} color='red' style={{
                        cursor: "pointer"
                    }} onClick={() => setTicket(prev => ({
                        ...prev, 
                        show: false
                    }))} />

                </div>

                <p style={{
                    fontFamily: fontType.title,
                    fontSize: 30
                }}>DATOS DE PAGO</p>

                <div style={{
                    width: "100%",
                    marginTop: 10,
                    marginBottom: 10,
                    fontFamily: fontType.text,
                    fontWeight: "bold"
                }}>
                    <p style={{
                        fontSize: 18,
                        fontWeight: "bold"
                    }}>Forma de pago:</p>
                </div>

                <div className='custom-select'>
                    <select id="FormaPago" name="FormaPago" style={{
                        fontFamily: fontType.text
                    }}
                        value={ticket.forma_pago}
                        onChange={e => {
                            onChangeOption(e.target.value)
                        }}
                    >
                        <option value="Efectivo">Efectivo</option>
                        <option value="Debito/Credito">Debito/Credito</option>
                        <option value="Transferencia">Transferencia</option>
                        <option value="Otro">Otro</option>
                    </select>
                </div>

                <div className='contComentarios' style={{
                    width: "80%",
                    height: 40,
                    marginTop: 10
                }}>
                    <input style={{
                        fontFamily: fontType.text
                    }} 
                        placeholder="Comentarios"
                        maxLength={100}
                        onChange={e => {
                                setTicket(prev => ({
                                    ...prev,
                                    comentarios: e.target.value
                                }))
                        }}
                    />
                </div>

                <button style={{
                    marginTop: 20,
                    padding: 20,
                    backgroundColor: main,
                    borderRadius: 5,
                    border: "none",
                    cursor: "pointer"
                }}
                    onClick={() => {
                        onHandleGenerateTicket()
                    }}
                >
                    <p style={{
                        color: "white",
                        fontSize: 16,
                        fontWeight: "bold",
                        fontFamily: fontType.subTitle
                    }}>GUARDAR PAGO</p>
                </button>

            </div>
        </div>
    )
}

export default TicketModal